module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAAA1BMVEW8IyWek5mIAAAADElEQVQYGWMYBVQFAAFQAAHUa/NpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ap-flag.png
// module id = 10714
// module chunks = 25